
import { activateVehicle, fetchTechniciansBeacons } from "@/apiCalls/apiCalls";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from "@/components/ui/dialog"
import { LoadingOutlined } from "@ant-design/icons";
import { errorNotification, successNotification } from "@/utils/Notification";
import { Button, Col, Form, Input, Modal, Row, Select, Spin } from "antd";
import { useEffect, useLayoutEffect, useState } from "react";
import { Assets } from "../assets/AssetColumns";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import axios from "axios"
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
interface ActivateVehicleProps {
    Assets: Assets
    setShowMainActivateDrawer: React.Dispatch<React.SetStateAction<boolean>>
    getAssets: any,
    beaconsToDisplay: any
}
const ActivateVehicle: React.FC<ActivateVehicleProps> = ({ Assets, setShowMainActivateDrawer, getAssets, beaconsToDisplay }) => {

    const [beaconsOptions, setBeaconsOptions] = useState([])
    const [form] = Form.useForm()
    const [submitting, setSubmitting] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();
    const [loadingtechnicianBeacon, setLoadingtechnicianBeacon] = useState(true);


    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (assets: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/crossTableOperation/activateVehicle', assets, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((data: any) => {
            console.log("this is the data.......", data)
            if (isMounted) {
                successNotification(
                    "vehicle  successfully activated",
                    "",
                    'topRight'
                )
                setShowMainActivateDrawer(false)
                getAssets()
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2))
    }



    useEffect(() => {
        const updatedBeaconsOptions: any = beaconsToDisplay.map((beacons: any) => ({
            label: beacons.cid,
            value: beacons.id
        }));
        setBeaconsOptions(updatedBeaconsOptions)
    }, [beaconsToDisplay])


    const handleLivestockSelect = (value: any) => { }

    const handleBeaconsChange = (value: any) => {
        console.log(value)
    }

    const filterBeaconsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }
    return (
        <>

            <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                    asset_id: Assets.id
                }}
                hideRequiredMark
            >
                <Form.Item
                    name="beacon_id"
                    label="Beacon cid"
                    rules={[{ required: true, message: 'Please select Beacon cid' }]}
                >
                    <Select
                        placeholder="Please select Beacon cid"
                        showSearch
                        className="text-black"
                        onSearch={handleBeaconsChange}
                        filterOption={filterBeaconsOptions}
                        onSelect={handleLivestockSelect}
                    >
                        {beaconsOptions.map((option: any) => (
                            <Option key={option.value} value={option.value}>{option.label}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="asset_id"
                    label="Asset_id"
                    hidden={true}
                    rules={[{ required: true, message: 'Please enter loan id' }]}
                >
                    <Input
                        placeholder="Please enter loan id"
                        className='focus:border-green-500 hover:border-green-500'

                    />
                </Form.Item>
                {/* {Assets.technician_store_id} */}
                <Form.Item>
                    <DialogFooter>
                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                            install
                        </Button>
                    </DialogFooter>
                </Form.Item>
            </Form>
            <Row>
                {submitting && <Spin indicator={antIcon} />}
            </Row>


        </>
    )
}

export default ActivateVehicle